<template>
    <div v-if="message.attachment_name" class="message-attachment mt-1">
        <button
            type="button"
            class="btn btn-light btn-sm text-left message-attachment-button"
            :disabled="downloading"
            @click="download"
        >
            <span class="d-block font-weight-bold">{{ message.attachment_name }}</span>
            <small class="d-block">
                {{ formatSize(message.attachment_size) }}
                <span aria-hidden="true"> · </span>
                {{ downloading ? 'Baixando…' : 'Baixar anexo' }}
            </small>
        </button>
        <small v-if="error" class="text-danger d-block mt-1" role="alert">{{ error }}</small>
    </div>
</template>

<script>
import { CHAT_CONVERSATION_URL, formatFileSize, requestErrorMessage } from './chatAttachments';

export default {
    props: {
        message: { type: Object, required: true },
    },
    data() {
        return { downloading: false, error: '' };
    },
    methods: {
        formatSize: formatFileSize,
        async download() {
            if (this.downloading) {
                return;
            }

            this.downloading = true;
            this.error = '';

            try {
                // Usa axios para conservar o token/interceptadores da autenticação api.
                const response = await axios.get(
                    `${CHAT_CONVERSATION_URL}/${encodeURIComponent(this.message.id)}/attachment`,
                    { responseType: 'blob', headers: { Accept: 'application/json' } }
                );

                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = this.message.attachment_name;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                link.remove();
                // Libera a referência após o navegador iniciar o download.
                setTimeout(() => window.URL.revokeObjectURL(url), 1000);
            } catch (error) {
                this.error = requestErrorMessage(error);
            } finally {
                this.downloading = false;
            }
        },
    },
};
</script>

<style scoped>
.message-attachment { max-width: 100%; }
.message-attachment-button { max-width: 100%; white-space: normal; overflow-wrap: anywhere; word-break: break-word; }
</style>
